{
  "ariaLabelRightButton": "Scroll til høyre",
  "ariaLabelLeftButton": "Scroll til venstre"
}
